import { render, staticRenderFns } from "./ProductVariantDatatable.vue?vue&type=template&id=3ab077c2"
import script from "./ProductVariantDatatable.ts?vue&type=script&lang=ts&external"
export * from "./ProductVariantDatatable.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports